import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FuseSearchBarModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { ToolbarComponent } from "app/layout/components/toolbar/toolbar.component";
import { NotificationServiceProxy } from "@api/core";
import { TrialMessageComponent } from "@app/layout/components/toolbar/trial-message/trial-message.component";
import { MatDividerModule } from "@angular/material/divider";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatBadgeModule } from "@angular/material/badge";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FuseDirectivesModule } from "../../../../@fuse/directives/directives";
import { TranslocoModule } from "@jsverse/transloco";
import { TranscriptionUsageAlertComponent } from "@vhealth/transcription/usage";

@NgModule({
    declarations: [ToolbarComponent, TrialMessageComponent],
    imports: [
        RouterModule,

        // The toolbar is in the initial bundle: import only the Material modules its template uses. (VS-1961)
        MatDividerModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatBadgeModule,
        MatDialogModule,
        MatTooltipModule,

        FuseDirectivesModule,
        FuseSharedModule,
        FuseSearchBarModule,

        TranslocoModule,
        TranscriptionUsageAlertComponent,
    ],
    exports: [ToolbarComponent, TrialMessageComponent],
    providers: [NotificationServiceProxy],
})
export class ToolbarModule {}
